// import React, { useState } from 'react'
// import { useCommon } from '../../../context/CommonContext';
// import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
// import { StyledButton, StyledCancelButton } from '../../StyledComponent';
// import { baseUrl, patch, post } from '../../../services/api-services';

// export default function AddProfile({ open, setOpen, customerId,fetchUserData }) {
//     const { setSnackbar, currentUser } = useCommon();
//     const [profile, setProfile] = useState("");
//     const handleClose = () => {
//         setOpen(false);
//     };
//     return (
//         <React.Fragment>
//             <Dialog
//                 open={open}
//                 onClose={handleClose}
//                 fullWidth
//                 PaperProps={{
//                     component: 'form',
//                     onSubmit: async (event) => {
//                         event.preventDefault();
//                         const formdata = new FormData();
//                         formdata.append('file', profile);
//                         const uploadRes = await post(`/Uploads/profile-pic/upload?access_token=${currentUser?.accessToken}`, formdata);
//                         if (uploadRes?.statusCode === 200) {
//                             const uploadedProfile = uploadRes?.data?.result?.files?.file[0]?.name;
//                             const res = await patch(`/Customers/${customerId}`, { image: uploadedProfile });
//                             if (res?.statusCode === 200) {
//                                 fetchUserData();
//                                 setSnackbar({
//                                     openSnackbar: true,
//                                     message: 'Profile added successfully!',
//                                     severity: 'success'
//                                 })
//                             }
//                         }
//                         handleClose();
//                     },
//                 }}
//             >
//                 <DialogTitle>Add Profile Picture</DialogTitle>
//                 <DialogContent className='flex flex-col gap-5'>
//                     <input type='file'
//                       accept="image/png, image/jpeg, image/jpg, image/webp"
//                         onChange={(e) => setProfile(e.target.files[0])}
//                     />
//                 </DialogContent>
//                 <DialogActions>
//                     <StyledCancelButton
//                         onClick={handleClose}>Cancel</StyledCancelButton>
//                     <StyledButton type="submit"  >SAVE</StyledButton>
//                 </DialogActions>
//             </Dialog>
//         </React.Fragment>
//     )
// }


import React, { useState } from 'react';
import { useCommon } from '../../../context/CommonContext';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { StyledButton, StyledCancelButton } from '../../StyledComponent';
import { baseUrl, patch, post } from '../../../services/api-services';

export default function AddProfile({ open, setOpen, customerId, fetchUserData }) {
  const { setSnackbar, currentUser } = useCommon();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setError(null); // Reset error when dialog is closed
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is an image
      if (file.type.startsWith('image/')) {
        setProfile(file);
        setError(null); // Reset error if a valid image is selected
      } else {
        setProfile(null);
        setError('Please select a valid image file.');
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!profile) return; // Don't proceed if there's no valid profile image

    const formdata = new FormData();
    formdata.append('file', profile);

    try {
      const uploadRes = await post(`/Uploads/profile-pic/upload?access_token=${currentUser?.accessToken}`, formdata);
      if (uploadRes?.statusCode === 200) {
        const uploadedProfile = uploadRes?.data?.result?.files?.file[0]?.name;
        const res = await patch(`/Customers/${customerId}`, { image: uploadedProfile });
        if (res?.statusCode === 200) {
          fetchUserData();
          setSnackbar({
            openSnackbar: true,
            message: 'Profile added successfully!',
            severity: 'success',
          });
          handleClose();
        }
      }
    } catch (error) {
      setSnackbar({
        openSnackbar: true,
        message: 'Failed to upload profile. Please try again.',
        severity: 'error',
      });
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        PaperProps={{
          component: 'form',
          onSubmit: handleSubmit,
        }}
      >
        <DialogTitle>Add Profile Picture</DialogTitle>
        <DialogContent className='flex flex-col gap-5'>
          <input
            type='file'
            accept="image/png, image/jpeg, image/jpg, image/webp"
            onChange={handleFileChange}
          />
          {error && <Typography color="error">{error}</Typography>}
        </DialogContent>
        <DialogActions>
          <StyledCancelButton onClick={handleClose}>Cancel</StyledCancelButton>
          <StyledButton type="submit" disabled={!profile}>
            SAVE
          </StyledButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

